import {
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory';

import { axiosI } from '@/plugins';
import { ApiHandler } from '@/submodules/postman-to-ts/apiHandler';

const integrations = createQueryKeys('integrations', {
  checkZoomAuthStatus: () => ({
    queryKey: ['zoomAuthStatus'],
    queryFn: async () => {
      const { method, path } =
        ApiHandler.integrations.zoom['oAuth2.0'].isAuthenticated;
      return (
        await axiosI(path(), {
          method,
        })
      ).data?.status;
    },
  }),
});

export const integrationsQueryKeys = mergeQueryKeys(integrations);
